// extracted by mini-css-extract-plugin
export default {"iconItemsContainer":"Mi0Fk2","iconItem":"u2ORAa","icon":"yf8_64","iconText":"MYIf3X"};